import React, { Component } from 'react';
import PostedJobView from './PostedJobView';
import { url } from '../../../Server/url/GlobalUrl';
import moment from 'moment';

class PostedJobComponent extends Component {
  state = {
    job_detail: [],
    modal_show: false,
    authResponse: '',
    card: true,
    list_active: '',
    card_active: 'active',
    expand: 'none',
    expand_id: '',
    length: 0,
  };
  hideCustomModal = () => {
    this.setState({ modal_show: false });
  };

  showCustomModal = () => {
    this.setState({ modal_show: true });
  };

  componentDidMount() {
    let auth = localStorage.getItem('token');
    fetch(url + '/jobs/job-post/?customer=' + localStorage.getItem('cv-id'), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + auth,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        console.log('result', result);
        if (result.length > 0) {
          this.setState({ length: result.length });

          var i;
          for (i of result) {
            if (
              i.start_date_arrival_time ||
              i.start_date_departure_time ||
              i.end_date_arrival_time ||
              i.end_date_departure_time
            ) {
              if (i.start_date_arrival_time) {
                var start_date_arrival_time = this.tConvert(
                  i.start_date_arrival_time
                );
                i['start_date_arrival_time'] = start_date_arrival_time;
              }
              if (i.start_date_departure_time) {
                var start_date_departure_time = this.tConvert(
                  i.start_date_departure_time
                );
                i['start_date_departure_time'] = start_date_departure_time;
              }
              if (i.end_date_arrival_time) {
                var end_date_arrival_time = this.tConvert(
                  i.end_date_arrival_time
                );
                i['end_date_arrival_time'] = end_date_arrival_time;
              }
              if (i.end_date_departure_time) {
                var end_date_departure_time = this.tConvert(
                  i.end_date_departure_time
                );
                i['end_date_departure_time'] = end_date_departure_time;
              }
            }
            if (i.start_date) {
              var day = moment(i.start_date).format('dddd DD/MM');
              i['start_shift'] =
                day +
                ' from ' +
                start_date_arrival_time +
                ' to ' +
                start_date_departure_time;
            }
            if (i.end_date) {
              var day = moment(i.end_date).format('dddd DD/MM');
              i['end_shift'] =
                day +
                ' from ' +
                end_date_arrival_time +
                ' to ' +
                end_date_departure_time;
            }
            if (i.qualification) {
              console.log(i.qualification);
              // console.log(JSON.parse(i.qualification))
              // console.log(Object.values(JSON.parse(i.qualification)).join(""))
              try {
                i['qualification'] = Object.values(
                  JSON.parse(i.qualification)
                ).join(',');
              } catch (err) {
                console.log(err);
              }
            }
          }
          this.setState({
            job_detail: result,
          });
        }
      });
  }
  tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      console.log('helllio', time);
      time.splice(-1, 1);
    }
    return time.join(''); // return adjusted time or original string
  }

  handlepreview = (id) => {
    console.log('id', id);
    let url = '/job-details/' + id;
    window.location.replace(url);
  };
  handelFormat = () => {
    console.log('yes i am in');
    if (this.state.card) {
      this.setState({
        card: false,
        list_active: 'active',
        card_active: '',
      });
    } else {
      this.setState({
        card: true,
        card_active: 'active',
        list_active: '',
      });
    }
  };
  handelcompression = (id) => {
    console.log('id', id);
    if (this.state.expand_id === id) {
      if (this.state.expand == 'block') {
        this.setState({ expand: 'none' });
        this.setState({ expand_id: id });
      } else {
        this.setState({ expand: 'block' });
      }
    } else {
      this.setState({ expand: 'block' });
      this.setState({ expand_id: id });
    }
  };
  handledelete = (id) => {
    console.log('hello all deleted', id);
    const token = localStorage.getItem('token');
    fetch(url + '/jobs/job-post/' + id + '/', {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }).then((response) => {
      console.log('response', response);
      if (
        response['status'] === 201 ||
        response['status'] === 200 ||
        response['status'] === 204
      ) {
        this.showCustomModal();
        this.setState({ authResponse: 'Deleted Successfully' });
        fetch(
          url + '/jobs/job-post/?customer=' + localStorage.getItem('cv-id'),
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + token,
            },
          }
        )
          .then((res) => res.json())
          .then((result) => {
            console.log('result', result);
            this.setState({
              job_detail: result,
            });
          });
      } else if (response['status'] === 400) {
        this.showCustomModal();
        this.setState({
          authResponse: 'Something went wrong please try again',
        });
      }
    });
  };

  render() {
    return (
      <PostedJobView
        job_detail={this.state.job_detail}
        handlepreview={this.handlepreview}
        handledelete={this.handledelete}
        authResponse={this.state.authResponse}
        modal_show={this.state.modal_show}
        hideCustomModal={this.hideCustomModal}
        card={this.state.card}
        handelFormat={this.handelFormat}
        card_active={this.state.card_active}
        list_active={this.state.list_active}
        handelcompression={this.handelcompression}
        expand={this.state.expand}
        expand_id={this.state.expand_id}
        length={this.state.length}
      />
    );
  }
}

export default PostedJobComponent;
